import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  createOutboundScenario,
  getOutboundScenarios,
  updateOutboundScenario,
} from '@/services/outbound-calls-service/scenarios.service';
import { OutboundScenarioPayload } from '@/services/outbound-calls-service/scenarios.service.types';
import { ReactQueryKeys } from '@/utils/react-query-keys';

/** Every scenario of the company, active or not: the lists are short, filtering is local. */
export const useOutboundScenarios = (companyId?: number) => {
  const { data, isLoading, error } = useQuery({
    queryKey: ReactQueryKeys.OUTBOUND_SCENARIOS(companyId),
    queryFn: () => getOutboundScenarios({ company_id: companyId! }),
    enabled: !!companyId,
  });

  return { scenarios: data?.scenarios ?? [], isLoading, error };
};

export const useCreateOutboundScenario = (companyId?: number) => {
  const queryClient = useQueryClient();

  const { mutateAsync, isPending } = useMutation({
    mutationFn: (payload: OutboundScenarioPayload) => createOutboundScenario(companyId!, payload),
    onSuccess: () =>
      queryClient.invalidateQueries({ queryKey: ReactQueryKeys.OUTBOUND_SCENARIOS_ALL() }),
  });

  return { createScenario: mutateAsync, isPending };
};

export const useUpdateOutboundScenario = () => {
  const queryClient = useQueryClient();

  const { mutateAsync, isPending } = useMutation({
    mutationFn: ({ id, payload }: { id: number; payload: Partial<OutboundScenarioPayload> }) =>
      updateOutboundScenario(id, payload),
    onSuccess: () =>
      queryClient.invalidateQueries({ queryKey: ReactQueryKeys.OUTBOUND_SCENARIOS_ALL() }),
  });

  return { updateScenario: mutateAsync, isPending };
};
